import { create } from 'zustand';

// Session-scoped token (supplier login returns it in the body — no refresh cookie flow).
const TOKEN = 'sp_token';
const NAME = 'sp_name';

interface AuthState {
  token: string | null;
  name: string | null;
  isAuthenticated: boolean;
  setSession: (token: string, name: string) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  token: sessionStorage.getItem(TOKEN),
  name: sessionStorage.getItem(NAME),
  isAuthenticated: !!sessionStorage.getItem(TOKEN),
  setSession: (token, name) => {
    sessionStorage.setItem(TOKEN, token);
    sessionStorage.setItem(NAME, name);
    set({ token, name, isAuthenticated: true });
  },
  logout: () => {
    sessionStorage.removeItem(TOKEN);
    sessionStorage.removeItem(NAME);
    set({ token: null, name: null, isAuthenticated: false });
  },
}));
